module.exports = __webpack_public_path__ + "img/pin-1.ccd1ef1d.svg";